import { updateComponentListMap } from "@/stores/configStore";
import { gameStore, setGameStore } from "@/stores/gameStore";

import { GameNode } from "./swagger/front";

export class GameHelper {
  private gameListMap: Map<number, GameNode> = new Map();

  constructor() {}

  insertGameDataByGid(game: GameNode) {
    if (!game.game_id) {
      return;
    }
    if (this.gameListMap.has(game.game_id)) {
      return;
    }

    this.gameListMap.set(game.game_id, game);
    this.setContinueGameList(game);
  }

  getGameDataByGid(gid: number) {
    if (!gid) {
      return null;
    }
    return this.gameListMap.get(gid);
  }
  // 设置继续游戏组件列表
  setContinueGameList(game: GameNode) {
    if (gameStore.continueGameList.length > 0) {
      setGameStore("continueGameList", (prev) => {
        // 去重
        const games = prev.filter((item) => item.game_id !== game.game_id);

        return [game, ...games].slice(0, 10);
      });
    } else {
      updateComponentListMap(game);
    }
  }
}
